const MarketplacePartnersFilter = (function ($) {
  let $els = {};
  let $grid;
  let filters = {
    cats: ["*"],
    levels: ["*"],
    discount: ["*"]
  };
  let defaultState = true;
  let qsRegex;

  const init = () => {
    _initDom();
    _addListeners();
  };

  const _initDom = () => {
    $els.catBtns = $("label.btn-tag").not(".btn-tag--all");
    $els.allCatsBtn = $(".btn-tag--all");
    $els.eventItems = $(".mp-card");
    $els.inputs = $("[data-target-cat]").not("[data-target-cat='all']");

    $els.typeFilterInputs = $("[data-group='types'] input");
    $els.typeFilterLabels = $("[data-group='types'] label");

    $els.discountCheckbox = $("#markpartHasDiscount");

    $els.noResults = $(".mp-card.no-results");
    $els.noResultsShowAll = $els.noResults.find("a");
    $els.clearAllBtn = $("#btn-clear-all-filters");

    $els.grid = $(".iso-container");
    $els.input = $("#cname-input");

    $grid = $els.grid.isotope({
      itemSelector: ".mp-card:not(.no-results)",
      filter: function () {
        return qsRegex ? $(this).text().match(qsRegex) : true;
      },
    });

    // if input has a value, run text filter
    if ($els.input.val()) {
      qsRegex = new RegExp($els.input.val(), "gi");
      $els.allCatsBtn.removeClass("active");
      $grid.isotope();
    } else {
      _setDefaultCatState();
    }
  };

  const _addListeners = () => {
    $els.noResultsShowAll.on("click", (e) => {
      _resetFilters(true);
    });

    $els.clearAllBtn.on("click", (e) => {
      _resetFilters(true);
    });

    $els.allCatsBtn.on("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      $els.input.val("");
      _setDefaultCatState();
    });

    $els.catBtns.on("click", (e) => {
      let $this = $(e.target);
      let $input = $this.find("input");
      let isChecked = $input.is(":checked");
      let targetCat = "." + $input.data("target-cat");
      let group = "cats";

      $els.input.val("");

      // create array for filter group, if not there yet
      let filterGroup = filters[group];
      if (!filterGroup) {
        filterGroup = filters[group] = [];
      }

      if (defaultState === true) {
        // first click on a category - deactivate the 'all' button
        $els.allCatsBtn.removeClass("active");
        // activeCats = [];
        filters["cats"] = [];
        defaultState = false;
      }

      if (!isChecked) {
        // add to active
        filters["cats"].push(targetCat);
        console.log ( filters["cats"] );

        if (filters["cats"].length === $els.inputs.length + 1 ) {
          // all items manually selected, set to 'all'
          _setDefaultCatState();
        } else {
          _updateActiveItems();
        }
      } else {
        // remove from active
        var targetIndex = filters["cats"].indexOf(targetCat);
        if (targetIndex > -1) {
          filters["cats"].splice(targetIndex, 1);

          if (filters["cats"].length === 0) {
            // all items manually deselected, set to 'all'
            _setDefaultCatState();
          }
        }

        _updateActiveItems();
      }
    });

    // use value of search field to filter
    let $quicksearch = $els.input.keyup(
      debounce(function () {
        _resetFilters(false);
        qsRegex = new RegExp($quicksearch.val(), "gi");
        $grid.isotope({
          filter: function () {
            // console.log(qsRegex ? $(this).text().match(qsRegex) : true);
            return qsRegex ? $(this).text().match(qsRegex) : true;
          },
        });
      }, 200)
    );

    // debounce so filtering doesn't happen every millisecond
    function debounce(fn, threshold) {
      let timeout;
      threshold = threshold || 100;
      return function debounced() {
        clearTimeout(timeout);
        let args = arguments;
        let _this = this;
        function delayed() {
          fn.apply(_this, args);
        }
        timeout = setTimeout(delayed, threshold);
      };
    }

    $els.typeFilterInputs.on("change", (e) => {
      let $this = $(e.target);
      // console.log($this.data("target-type"));
      filters["type"] =
        $this.data("target-type") === "all"
          ? ["*"]
          : ["." + $this.data("target-type")];

      $els.input.val("");

      _updateActiveItems();
    });

    $els.discountCheckbox.on("change", (e) => {
      filters["discount"] = e.currentTarget.checked ? [".has-discount"] : ["*"];

      $els.input.val("");

      _updateActiveItems();
    });

    $grid.on("arrangeComplete", function (event, filteredItems) {
      if (filteredItems.length > 0) {
        $els.noResults.css("opacity", 0);
      } else {
        $els.noResults.css("opacity", 1);
      }
    });
  };

  const _setDefaultCatState = () => {
    filters["cats"] = [];
    defaultState = true;

    $els.allCatsBtn.addClass("active");

    $.each($els.inputs, function (i, val) {
      let catClass = "." + $(val).data("target-cat");
      filters["cats"].push(catClass);
    });

    $.each($els.catBtns, function (i, val) {
      setTimeout(() => {
        $(val).removeClass("active").removeClass("focus");
        $els.inputs.prop("checked", false);
      }, 100);
    });

    _updateActiveItems();
  };

  const _resetFilters = (includeSearch = false) => {
    filters = {
      cats: ["*"],
      levels: ["*"],
      discount: ["*"],
    };

    $els.typeFilterInputAll = $("[data-group='types'] label:first-of-type");
    $els.typeFilterLabels.removeClass("active");
    $els.typeFilterLabels.eq(0).addClass("active");
    $els.discountCheckbox.prop("checked", false);


    if(includeSearch) $els.input.val("");

    _setDefaultCatState();
  };

  const _updateActiveItems = () => {
    let comboFilters = _getComboFilter(filters);

    $grid.isotope({ filter: comboFilters });
    // $(".filter-display").text(comboFilters);
    console.log(comboFilters);
  };

  const _getComboFilter = (filters) => {
    let i = 0;
    let comboFilters = [];
    let message = [];

    for (let prop in filters) {
      message.push(filters[prop].join(" "));
      let filterGroup = filters[prop];
      // skip to next filter group if it doesn't have any values
      if (!filterGroup.length) {
        continue;
      }
      if (i === 0) {
        // copy to new array
        comboFilters = filterGroup.slice(0);
      } else {
        let filterSelectors = [];
        // copy to fresh array
        let groupCombo = comboFilters.slice(0); // [ A, B ]
        // merge filter Groups
        for (let k = 0, len3 = filterGroup.length; k < len3; k++) {
          for (let j = 0, len2 = groupCombo.length; j < len2; j++) {
            filterSelectors.push(groupCombo[j] + filterGroup[k]); // [ 1, 2 ]
          }
        }
        // apply filter selectors to combo filters for next group
        comboFilters = filterSelectors;
      }
      i++;
    }

    let comboFilter = comboFilters.join(", ");
    return comboFilter;
  };

  module.exports = {
    init: init,
  };
})(jQuery);
